import React, { ReactNode } from "react";
import { get } from "lodash";
import DOMPurify from "dompurify";
import { DerbyEventStatus, HomepageEventBannerText } from "@fdr/types/ts/Derby";
import { leaf } from "@fdr/static-ui/Icons/icons";
import {
  Container,
  Row,
  Column,
  LeafIcon,
  DerbyTitle
} from "./styled-components";
import { Countdown } from "../../_atoms/Countdown";

interface Props {
  title?: HomepageEventBannerText;
  subtitle?: HomepageEventBannerText;
  description?: HomepageEventBannerText;
  raceStartDate?: Date | null;
  raceStatus: DerbyEventStatus;
  children: ReactNode;
  forceFullDate?: boolean;
  raceNumber?: number;
}

const formatEventText = (text: string) => {
  const startTag = "[";
  const endTag = "]";

  return text.split(startTag).join("<b>").split(endTag).join("</b>");
};

const HomeHeaderHeadline = ({
  title,
  subtitle,
  description,
  raceStartDate,
  raceStatus = DerbyEventStatus.POST,
  children,
  forceFullDate = false,
  raceNumber
}: Props) => {
  const hasEventEnded = raceStatus === DerbyEventStatus.POST;
  return (
    <Container>
      <Row>
        {!hasEventEnded && <LeafIcon icon={leaf} viewBoxSize="0 0 24 40" />}
        <Column>
          <DerbyTitle
            data-qa-label="derby-title"
            hasEventEnded={hasEventEnded}
            $fontSize={get(title, "size", 0)}
            dangerouslySetInnerHTML={{
              __html:
                typeof window !== "undefined"
                  ? DOMPurify.sanitize(formatEventText(get(title, "label", "")))
                  : formatEventText(get(title, "label", ""))
            }}
          />
          {!hasEventEnded && (
            <DerbyTitle
              className="derby-subtitle"
              hasEventEnded={hasEventEnded}
              data-qa-label="derby-subtitle"
              $fontSize={get(subtitle, "size", 12)}
              dangerouslySetInnerHTML={{
                __html:
                  typeof window !== "undefined"
                    ? DOMPurify.sanitize(
                        formatEventText(get(subtitle, "label", ""))
                      )
                    : formatEventText(get(subtitle, "label", ""))
              }}
            />
          )}
          <Countdown
            endDate={raceStartDate}
            raceStatus={raceStatus}
            qaLabel="countdown"
            forceFullDate={forceFullDate}
            raceNumber={raceNumber}
            description={
              description && {
                ...description,
                label: formatEventText(get(description, "label", ""))
              }
            }
          />
        </Column>
        {!hasEventEnded && <LeafIcon icon={leaf} viewBoxSize="0 0 24 40" />}
      </Row>
      {children}
    </Container>
  );
};

export default HomeHeaderHeadline;
